export const PLATFORMS = ['comcast', 'core', 'ps5', 'samsung', 'vega', 'vizio', 'webos', 'xbox'];

export const MODEL_YEAR_UNKNOWN = 'N/A';
